import React from 'react';
import './wave.css'; 

const Background = () => (
    <div>
        <img className="bottom-left-image" src="/Picture2.png" alt="Bottom Left" style={{ position: 'fixed', bottom: 0, left: -10 }} />
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100vh', zIndex: -1 }}>
            <section>   
                <div className='air air1'></div>
                <div className='air air2'></div>
                <div className='air air3'></div>
                <div className='air air4'></div>
            </section>
        </div>
    </div>
   
);

export default Background;